<template>
    <div class="customCheckbox checkbox">
        <label>
            <input type="checkbox" v-model="state" :disabled="disabled"> <slot></slot>
        </label>
    </div>
</template>

<script>
  export default {
    name: "checkbox",
    props: {
      'value': {},
      'disabled': {},
      'selectValue': {
        default: true
      }
    },
    computed: {
      id() {
        return _.uniqueId();
      },
      state: {
        get: function() {
          return this.value === this.selectValue;
        },
        set: function(newValue) {
          if(newValue === true){
            this.$emit('input', this.selectValue);
          }else if (_.isBoolean(this.selectValue)){
            this.$emit('input', newValue);
          }
        }
      }
    }
  }
</script>

<style>
    .customCheckbox.checkbox label{
        font-size: 1.3em;
    }

    .customCheckbox input[type="checkbox"],
    .customCheckbox.checkbox input[type="checkbox"],
    .customCheckbox.checkbox-inline input[type="checkbox"] {
        position: relative;
        border: none;
        margin-bottom: -4px;
        -webkit-appearance: none;
        appearance: none;
        cursor: pointer;
    }
    .customCheckbox input[type="checkbox"]:focus,
    .customCheckbox.checkbox input[type="checkbox"]:focus,
    .customCheckbox.checkbox-inline input[type="checkbox"]:focus {
        outline: none;
    }
    .customCheckbox input[type="checkbox"]:focus:after,
    .customCheckbox.checkbox input[type="checkbox"]:focus:after,
    .customCheckbox.checkbox-inline input[type="checkbox"]:focus:after {
        border-color: #d5230f;
    }
    .customCheckbox input[type="checkbox"]:after,
    .customCheckbox.checkbox input[type="checkbox"]:after,
    .customCheckbox.checkbox-inline input[type="checkbox"]:after {
        content: "";
        display: block;
        width: 28px;
        height: 28px;
        margin-top: -2px;
        margin-right: 5px;
        border: 2px solid #666666;
        border-radius: 2px;
        -webkit-transition: 240ms;
        -o-transition: 240ms;
        transition: 240ms;
    }
    .customCheckbox input[type="checkbox"]:checked:before,
    .customCheckbox.checkbox input[type="checkbox"]:checked:before,
    .customCheckbox.checkbox-inline input[type="checkbox"]:checked:before {
        content: "";
        position: absolute;
        top: 1px;
        left: 10px;
        display: table;
        width: 9px;
        height: 19px;
        border: 4px solid #fff;
        border-top-width: 0;
        border-left-width: 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    .customCheckbox input[type="checkbox"]:checked:after,
    .customCheckbox.checkbox input[type="checkbox"]:checked:after,
    .customCheckbox.checkbox-inline input[type="checkbox"]:checked:after {
        background-color: #d5230f;
        border-color: #d5230f;
    }
    .customCheckbox input[type="checkbox"]:disabled:after,
    .customCheckbox.checkbox input[type="checkbox"]:disabled:after,
    .customCheckbox.checkbox-inline input[type="checkbox"]:disabled:after {
        border-color: #bbbbbb;
    }
    .customCheckbox input[type="checkbox"]:disabled:checked:after,
    .customCheckbox.checkbox input[type="checkbox"]:disabled:checked:after,
    .customCheckbox.checkbox-inline input[type="checkbox"]:disabled:checked:after {
        background-color: #bbbbbb;
        border-color: transparent;
    }
</style>